import {Button} from '@/components/ui/button'

export type OpcionEstado<V extends string> = {
  valor: V
  /** Sin el número: el conteo lo pinta el componente. */
  etiqueta: string
  /** `undefined` pinta solo el rótulo; `null` esconde la opción: un filtro que siempre vuelve vacío es
   * peor que no ofrecerlo. */
  conteo?: number | null
}

/** El llamador filtra en el servidor (R6) y vuelve a la página 1 al cambiar de chip; el componente solo
 * emite el valor. */
export function FiltrosDeEstado<V extends string>({
  opciones,
  valor,
  onValor,
  testIdPrefijo,
}: {
  opciones: OpcionEstado<V>[]
  valor: V
  onValor: (valor: V) => void
  /** El testid de cada botón es `${testIdPrefijo}-${opcion.valor}`. */
  testIdPrefijo: string
}) {
  return (
    <div className="flex flex-wrap gap-1">
      {opciones
        .filter((opcion) => opcion.conteo !== null)
        .map((opcion) => (
          <Button
            key={opcion.valor}
            type="button"
            size="sm"
            variant={valor === opcion.valor ? 'default' : 'outline'}
            data-testid={`${testIdPrefijo}-${opcion.valor}`}
            onClick={() => onValor(opcion.valor)}>
            {opcion.conteo === undefined ? opcion.etiqueta : `${opcion.etiqueta} (${opcion.conteo})`}
          </Button>
        ))}
    </div>
  )
}
